<template>
  <div class="toggler" :class="{ disabled: disabled }">
    <div @click="isExpanded = !isExpanded">
      <span class="title">
        <span v-if="label">{{ label }}</span>
        <b-icon v-if="icon" :icon="icon" />
        <strong v-if="bold">{{ title }}</strong>
        <span v-else>{{ title }}</span>
      </span>
    </div>
    <slot></slot>
    <slot v-if="isExpanded" name="expand"> </slot>
  </div>
</template>

<script>
import autosize from 'autosize';

export default {
  name: 'Toggler',
  data: function () {
    return {
      isExpanded: !!this.expanded,
    };
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    bold: {
      type: Boolean,
      default: false,
    },
  },
  updated: function () {
    this.$nextTick(function () {
      const textareas = document.querySelectorAll('textarea');
      autosize(textareas);
    });
  },
};
</script>

<style scoped>
h2 {
  font-weight: bold;
}

.toggler {
  display: block;
  width: 100%;
  padding: 20px 0;
}

.title {
  text-align: center;
  display: block;
  font-size: 1.2em;
  cursor: pointer;
  padding: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/toolbar/Toggler.vue